import React from 'react'
import './CounterInput.scss'

export function CounterInput({ value = 1, onChange, disabled = false }) {
    return (
        <div className="CounterInput">
            <button disabled={disabled} onClick={() => onChange(value - 1)}>
                <svg width="8" height="3" viewBox="0 0 8 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 2.068V0.5H7.46667V2.068H0Z" fill="#212121" />
                </svg>

            </button>
            <div className='CounterInput__val'>{value}</div>
            <button disabled={disabled} onClick={() => onChange(value + 1)}>
                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.49452 10.9264V6.43185H0V4.99452H4.49452V0.5H5.93185V4.99452H10.415V6.43185H5.93185V10.9264H4.49452Z" fill="#212121" />
                </svg>

            </button>
        </div>
    )
}